// components/AdminEditForm.jsx
import React, { useState } from "react";
import PropTypes from "prop-types";
import FormInput from "./FormInput";
import SubmitButton from "./SubmitButton";
import { updateAdmin } from "../api/vipform";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

export default function AdminEditForm({ adminData, onBack }) {
  const navigate = useNavigate();

  const [adminformData, setAdminFormData] = useState({
    ...adminData,
    adminPassword: "", // always start empty
  });

  const handle_ad_change = (e) => {
    const { name, value } = e.target;
    setAdminFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handle_ad_submit = async (e) => {
    e.preventDefault();

    const payload = { ...adminformData };
    if (!payload.adminPassword) delete payload.adminPassword;

    try {
      await updateAdmin(adminformData.id, payload);
      toast.success("Admin updated successfully!");

      setTimeout(() => {
        navigate("/login");
      }, 1000);
    } catch (error) {
      console.error(error);
      toast.error("Failed to update Admin");
    }
  };

  return (
    <div className="editform-wrapper">
      <div className="editform-card">
        <div className="card-header">
          <h1>
            <i className="fas fa-user-cog"></i> Edit Admin Profile
          </h1>
          <p>Update your account details securely.</p>
        </div>

        <form onSubmit={handle_ad_submit} className="edit-form">
          <FormInput
            label="Full Name"
            name="adminName"
            value={adminformData.adminName}
            onChange={handle_ad_change}
            isEdit={true}
          />

          <FormInput
            label="Username"
            name="adminUsername"
            value={adminformData.adminUsername}
            onChange={handle_ad_change}
            isEdit={true}
          />

          <FormInput
            label="Email"
            name="adminEmail"
            value={adminformData.adminEmail}
            onChange={handle_ad_change}
            isEdit={true}
          />

          <FormInput
            label="New Password (leave blank to keep current)"
            name="adminPassword"
            type="password"
            value={adminformData.adminPassword}
            onChange={handle_ad_change}
            isEdit={true}
            placeholder="••••••••"
          />

          <FormInput
            label="Contact Number"
            name="contactNo"
            value={adminformData.contactNo}
            onChange={handle_ad_change}
            isEdit={true}
          />

          <div className="button-group">
            <SubmitButton label="Update Admin" />

            <button
              type="button"
              onClick={onBack}
              className="cancel-btn"
            >
              <i className="fas fa-arrow-left"></i> Back to Profile
            </button>
          </div>
        </form>
      </div>

      <style jsx>{`
        .editform-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          color: #e2e8f0;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem 1rem;
        }

        .editform-card {
          width: 100%;
          max-width: 560px;
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(16px);
          border-radius: 20px;
          padding: 3rem 2.5rem;
          border: 1px solid rgba(59, 130, 246, 0.3);
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.4);
          transition: all 0.3s ease;
        }

        .editform-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 25px 50px rgba(59, 130, 246, 0.2);
        }

        .card-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }

        .card-header h1 {
          font-size: 2rem;
          font-weight: 700;
          color: #60a5fa;
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.8rem;
        }

        .card-header p {
          opacity: 0.85;
          font-size: 1.05rem;
        }

        .edit-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
        }

        .button-group {
          display: flex;
          flex-direction: column;
          gap: 1rem;
          margin-top: 1.5rem;
        }

        .cancel-btn {
          background: transparent;
          color: #94a3b8;
          border: 2px solid #475569;
          padding: 0.9rem 1.5rem;
          border-radius: 14px;
          font-weight: 600;
          font-size: 1rem;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.6rem;
        }

        .cancel-btn:hover {
          background: #475569;
          color: white;
          border-color: #60a5fa;
          transform: translateY(-2px);
        }

        @media (max-width: 576px) {
          .editform-card {
            padding: 2rem 1.5rem;
            margin: 0 1rem;
          }

          .card-header h1 {
            font-size: 1.7rem;
          }

          .card-header p {
            font-size: 0.95rem;
          }
        }
      `}</style>
    </div>
  );
}

AdminEditForm.propTypes = {
  adminData: PropTypes.object.isRequired,
  onBack: PropTypes.func.isRequired,
};



// // components/AdminEditForm.jsx
// import React, { useState } from "react";
// import PropTypes from "prop-types";
// import FormInput from "./FormInput";
// import SubmitButton from "./SubmitButton";
// import { updateAdmin } from "../api/vipform";
// import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";   //  ADD THIS

// export default function AdminEditForm({ adminData, onBack }) {
//   const navigate = useNavigate(); //  INITIALIZE NAVIGATE

//   // -------- INITIAL STATE --------
//   const [adminformData, setAdminFormData] = useState({
//     ...adminData,
//     adminPassword: "", // always start empty
//   });

//   // -------- INPUT CHANGE HANDLER --------
//   const handle_ad_change = (e) => {
//     const { name, value } = e.target;
//     setAdminFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // -------- SUBMIT --------
//   const handle_ad_submit = async (e) => {
//     e.preventDefault();

//     const payload = { ...adminformData };

//     // Don't send empty password
//     if (!payload.adminPassword) delete payload.adminPassword;

//     try {
//       await updateAdmin(adminformData.id, payload);
//       toast.success("Admin updated successfully!");

//       //  Redirect to login after update
//       setTimeout(() => {
//         navigate("/login");
//       }, 1000);

//     } catch (error) {
//       console.error(error);
//       toast.error("Failed to update Admin");
//     }
//   };

//   return (
//     <div style={styles.page}>
//       <div style={styles.container}>

//         {/* LEFT BLUE SIDEBAR */}
//         <div style={styles.leftBox}>
//           <h2 style={styles.leftTitle}>ADMIN PROFILE</h2>
//           <p style={styles.desc}>
//             Update your admin details securely and easily.
//           </p>

//           <button style={styles.haveBtn} onClick={onBack}>
//             Back to Profile
//           </button>
//         </div>

//         {/* RIGHT FORM */}
//         <div style={styles.formBox}>
//           <h2 style={styles.formTitle}>Edit Admin Details</h2>

//           <form onSubmit={handle_ad_submit}>
//             <FormInput
//               label="Full Name"
//               name="adminName"
//               value={adminformData.adminName}
//               onChange={handle_ad_change}
//               isEdit={true}
//             />

//             <FormInput
//               label="Username"
//               name="adminUsername"
//               value={adminformData.adminUsername}
//               onChange={handle_ad_change}
//               isEdit={true}
//             />

//             <FormInput
//               label="Email"
//               name="adminEmail"
//               value={adminformData.adminEmail}
//               onChange={handle_ad_change}
//               isEdit={true}
//             />

//             {/* PASSWORD FIELD */}
//             <FormInput
//               label="Password"
//               name="adminPassword"
//               type="text"
//               value={adminformData.adminPassword}
//               onChange={handle_ad_change}
//               isEdit={true}
//             />

//             <FormInput
//               label="Contact Number"
//               name="contactNo"
//               value={adminformData.contactNo}
//               onChange={handle_ad_change}
//               isEdit={true}
//             />

//             <SubmitButton label="Update" />

//             <button
//               type="button"
//               onClick={onBack}
//               className="btn btn-secondary w-100 mt-3"
//             >
//               Cancel
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ---------- PROP VALIDATION ---------- */
// AdminEditForm.propTypes = {
//   adminData: PropTypes.object.isRequired,
//   onBack: PropTypes.func.isRequired,
// };

// /* ---------- STYLES ---------- */
// const styles = {
//   page: {
//     width: "100%",
//     background: "#f4f6f9",
//   },

//   container: {
//     minHeight: "100vh",
//     width: "100%",
//     display: "flex",
//     boxShadow: "0 0 25px rgba(0,0,0,0.15)",
//   },

//   leftBox: {
//     width: "40%",
//     background: "#1e73be",
//     padding: "40px",
//     color: "white",
//   },

//   leftTitle: {
//     fontSize: "28px",
//     fontWeight: "700",
//     marginBottom: "20px",
//   },

//   desc: {
//     fontSize: "15px",
//     marginBottom: "20px",
//     lineHeight: "1.5",
//   },

//   haveBtn: {
//     background: "white",
//     color: "#1e73be",
//     border: "none",
//     padding: "12px 25px",
//     borderRadius: "5px",
//     cursor: "pointer",
//   },

//   formBox: {
//     width: "60%",
//     padding: "40px",
//     background: "#fff",
//   },

//   formTitle: {
//     fontSize: "26px",
//     fontWeight: "700",
//     color: "#1e73be",
//     marginBottom: "20px",
//     textAlign: "left",
//   },
// };
